/**
 * Navigates to a social share URL (a platform OAuth page or our own
 * oauth2 bounce page). Social platforms refuse to render inside iframes
 * (X-Frame-Options: deny), so when the app itself is embedded the flow
 * must leave the frame and run in a centered popup window. The share
 * completion endpoints authorize via the share `state` param rather than
 * the session, so the new tab works without the iframe's (partitioned)
 * session.
 */
const POPUP_WIDTH = 600;
const POPUP_HEIGHT = 760;

const buildPopupFeatures = (): string => {
  const width = Math.min(POPUP_WIDTH, globalThis.screen.availWidth);
  const height = Math.min(POPUP_HEIGHT, globalThis.screen.availHeight);
  const left = Math.max(
    0,
    globalThis.screenX + (globalThis.outerWidth - width) / 2,
  );
  const top = Math.max(
    0,
    globalThis.screenY + (globalThis.outerHeight - height) / 2,
  );

  return `popup,width=${width},height=${height},left=${Math.round(left)},top=${Math.round(top)}`;
};

export const navigateToSocialShareUrl = (shareUrl: string): void => {
  const isEmbedded = globalThis.self !== globalThis.top;

  if (isEmbedded) {
    // The preceding API calls happen between the user's click and this
    // point; browsers allow window.open during the click's transient
    // activation window (~5s), which covers them. If the popup is still
    // blocked, fall through to in-frame navigation — no worse than the
    // pre-popup behavior.
    const popup = globalThis.open(shareUrl, '_blank', buildPopupFeatures());
    if (popup) {
      return;
    }
  }

  globalThis.location.href = shareUrl;
};
